import React from 'react'
import { Flex } from '@chakra-ui/react'

export const Table = React.forwardRef((props, ref) => {
  return (
    <Flex ref={ref} flex='1' direction='column' w='min-content' minW='100% !important' maxH='100%' css={{ borderCollapse: 'collapse' }} {...props} />
  )
})
